import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";
import { ThemeContext } from "./ContextProvider/ThemeContextProvider";
import Home from "./Pages";

function App() {
  const { mode } = React.useContext(ThemeContext);
  return (
    <Router>
      <div
        style={
          mode === "dark"
            ? { background: "black", zIndex: "1", overflow: "hidden" }
            : { background: "white", overflow: "hidden" }
        }
      >
        <Home />
      </div>
    </Router>
  );
}

export default App;
